module.exports = __webpack_public_path__ + "static/media/O65-1000.07277fef.jpg";